<template>
    <header :class="`publisher-${publisher.id}`">
        <div class="header-constraint constrain bc">
            <div class="flex flex-align">
                <router-link class="wordmark" :to="{name: 'library'}">
                    <img :src="publisher.data.wordmark" />
                </router-link>
                <div class="integration">{{integration.team.name}}</div>
                <div class="ff"></div>
                <div class="flex flex-align user-metadata" @click="options">
                    <div class="username destination">{{user.name}}</div>
                    <profile :user="user" class="profile-picture" />
                </div>
            </div>
        </div>
    </header>
</template>

<script>
    import Options from '@/components/modals/Options.vue';

    export default {
        name: 'Header',
        data(){
            return {
                gdpr: true
            };
        },
        methods: {
            options(){
                const _this = this;

                this.$modal.show(Options, {
                    options: [
                        {
                            color: 'red',
                            title: 'Sign Out',
                            fn(){
                                _this.$store.dispatch('sessions/stopSessionExtension')
                                _this.$store.dispatch('sessions/stopLoginSessionExtension')
                                _this.$store.dispatch('user/logout')
                                .then(() => _this.$router.push({name: 'home'}))
                                .catch(() => _this.$toasted.error('There was an error logging you out.'));
                            }
                        }
                    ]
                },
                {
                    width: 260,
                    height: 'auto',
                    classes: 'modal'
                });
            },
            close(){
                localStorage.setItem('cosmos-gdpr', true);
                this.gdpr = false;
            }
        },
        created(){
            if(localStorage.getItem('cosmos-gdpr')){
                this.gdpr = false;
            }
        },
        computed: {
            publisher(){
                return this.$store.getters.publisher;
            },
            integration(){
                return this.$store.getters.integration;
            },
            product(){
                return this.$store.getters.product;
            },
            user(){
                return this.$store.state.user;
            }
        }
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";

    header
    {
        &.publisher-600016620787
        {
            .wordmark
            {
                height: 40px;

                img
                {
                    margin-top: -8px;
                    max-height: 60px;
                    display: block;
                }
            }
        }

        .wordmark
        {
            height: 40px;

            img
            {
                max-height: 40px;
                display: block;
            }
        }

        .slash
        {
            color: @c;
            font-weight: 300;
            margin: 0 10px;
        }

        .breadcrumb
        {
            color: @grey;
            font-weight: 400;
            letter-spacing: -0.02rem;
        }

        .username
        {
            color: var(--primary-text-color);
        }

        .profile-picture
        {
            width: 32px;
            height: 32px;
            margin-left: 10px;
            cursor: pointer;
            border-radius: 16px;
            overflow: hidden;

            img
            {
                width: 32px;
                height: 32px;
            }
        }

        .register
        {
            margin-left: 30px;
        }
    }

    .integration
    {
        color: @black;
        font-size: 15px;
        font-weight: 500;
        margin-left: 15px;
    }

    .logo
    {
        height: 50px;
        width: 31px;
        display: block;
        background: url('~@/assets/rings.svg') 0 11px no-repeat;
        background-size: 31px auto;
    }

    .header-constraint
    {
        padding-top: 14px;

        .button
        {
            margin-left: 30px;
            line-height: 32px;
            height: 32px;
        }
    }

    .organization-switch
    {
        width: 17px;
        height: 28px;
        border-radius: 2px;
        margin-left: 8px;
        background: url('~@/assets/icons/black/select.svg') -1px 6px no-repeat;
        background-size: 18px auto;
        cursor: pointer;

        &:hover, &:active
        {
            background-color: @e;
        }
    }

    [theme="dark"]
    {
        .organization-switch
        {
            background-image: url('~@/assets/icons/white/select.svg');

            &:hover, &:active
            {
                background-color: #333;
            }
        }
    }

    .gdpr-ribbon
    {
        height: 48px;
        background: var(--card-background-color);
        color: var(--primary-text-color);
        font-weight: 500;
        font-size: 14px;

        .constrain
        {
            height: 100%;
        }

        .text-button.border
        {
            font-size: 12px;
            padding: 2px 10px;
            margin-left: 10px;

            &:hover, &:active
            {
                background: transparent;
            }
        }
    }
</style>
